module.exports = __webpack_public_path__ + "img/yj02.a4c112b1.png";